
<template>
  <div class="main-content">
    <Container
      :title="t('route.shoppingAddress')"
      :hasLine="true"
    >
      <template #header>
        <SearchForm
          ref="searchFormRef"
          :formModel="searchFormModel"
          :formStruct="searchFormStruct"
          :submitButton="t('common.search')"
          :resetButton="t('common.reset')"
          @submit="submitSearch"
          @reset="resetForm"
        />
      </template>
      <template #main>
        <el-button
          v-if="this.$hasPermission(['ACTION_vcShoppingAddressEdit'])"
          @click="handleCreate()"
          type="success"
        >
          {{ t('table.add') }}
        </el-button>
        <el-button
          v-if="selection.length > 0 && this.$hasPermission(['ACTION_vcShoppingAddressEdit'])"
          @click="handleBathDelete()"
          type="danger"
        >
          {{ t('table.bathDelete') }}
        </el-button>
        <SimpleTable
          :isLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :sort="sort"
          :order="order"
          @handleOrder="handleOrder"
          @handleSelection="handleSelection"
        >
          <template
            v-if="this.$hasPermission(['ACTION_vcShoppingAddressEdit'])"
            #default="slotProps"
          >
            <el-button
              @click="handleEdit(slotProps.row)"
              type="primary"
              size="mini"
            >
              {{ t('common.edit') }}
            </el-button>
            <el-button
              @click="handleDelete(slotProps.row.id)"
              type="danger"
              size="mini"
            >
              {{ t('common.delete') }}
            </el-button>
          </template>
        </SimpleTable>
        <el-pagination
          :total="total"
          v-show="total > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          :current-page="page"
          :page-sizes="[5, 10, 20]"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;"
        />
      </template>
    </Container>
    <el-dialog
      v-if="this.$hasPermission(['ACTION_vcShoppingAddressEdit'])"
      :title="t(textMap[dialogStatus])"
      center
      v-model="dialogFormVisible"
      width="45%"
    >
      <NomalContainer>
        <CenterForm
          v-if="dialogStatus === 'create'"
          :formModel="createModel"
          :formStruct="createStruct"
          :formRules="shoppingAddressRole"
          @submit="createSubmit"
          @reset="createReset"
        />
        <CenterForm
          v-if="dialogStatus === 'update'"
          :formModel="updateModel"
          :formStruct="updateStruct"
          :formRules="shoppingAddressRole"
          @submit="updateNameSubmit"
          @reset="updateNameReset"
        />
      </NomalContainer>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import {
  ShoppingAddressModel,
  ShoppingAddressPageSearchModel,
  ShoppingAddressSearchModel,
  ShoppingAddressAddModel,
  ShoppingAddressUpdateModel,
  IdsModel
} from '@/model/product/ShoppingAddressModel'
import {
  pageSearchShoppingAddress,
  addShoppingAddress,
  updateShoppingAddress,
  removeShoppingAddress,
  batchRemoveShoppingAddress
} from '@/apis/product/shoppingAddress'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    NomalContainer
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const searchStruct = [
      { prop: 'userName', label: t('shoppingAddress.userName'), placeholder: t('shoppingAddress.userNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'customerName', label: t('shoppingAddress.customerName'), placeholder: t('shoppingAddress.customerNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'telephone', label: t('shoppingAddress.telephone'), placeholder: t('shoppingAddress.telephoneP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressSheng', label: t('shoppingAddress.addressSheng'), placeholder: t('shoppingAddress.addressShengP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressShi', label: t('shoppingAddress.addressShi'), placeholder: t('shoppingAddress.addressShiP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressXian', label: t('shoppingAddress.addressXian'), placeholder: t('shoppingAddress.addressXianP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressStreet', label: t('shoppingAddress.addressStreet'), placeholder: t('shoppingAddress.addressStreetP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressDetails', label: t('shoppingAddress.addressDetails'), placeholder: t('shoppingAddress.addressDetailsP'), component: 'el-input', type: 'text', model: null }
    ]

    const createStruct = [
      { prop: 'userName', label: t('shoppingAddress.userName'), placeholder: t('shoppingAddress.userNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'customerName', label: t('shoppingAddress.customerName'), placeholder: t('shoppingAddress.customerNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'telephone', label: t('shoppingAddress.telephone'), placeholder: t('shoppingAddress.telephoneP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressSheng', label: t('shoppingAddress.addressSheng'), placeholder: t('shoppingAddress.addressShengP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressShi', label: t('shoppingAddress.addressShi'), placeholder: t('shoppingAddress.addressShiP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressXian', label: t('shoppingAddress.addressXian'), placeholder: t('shoppingAddress.addressXianP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressStreet', label: t('shoppingAddress.addressStreet'), placeholder: t('shoppingAddress.addressStreetP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressDetails', label: t('shoppingAddress.addressDetails'), placeholder: t('shoppingAddress.addressDetailsP'), component: 'el-input', type: 'text', model: null }
    ]

    const updateStruct = [
      { prop: 'userName', label: t('shoppingAddress.userName'), placeholder: t('shoppingAddress.userNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'customerName', label: t('shoppingAddress.customerName'), placeholder: t('shoppingAddress.customerNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'telephone', label: t('shoppingAddress.telephone'), placeholder: t('shoppingAddress.telephoneP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressSheng', label: t('shoppingAddress.addressSheng'), placeholder: t('shoppingAddress.addressShengP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressShi', label: t('shoppingAddress.addressShi'), placeholder: t('shoppingAddress.addressShiP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressXian', label: t('shoppingAddress.addressXian'), placeholder: t('shoppingAddress.addressXianP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressStreet', label: t('shoppingAddress.addressStreet'), placeholder: t('shoppingAddress.addressStreetP'), component: 'el-input', type: 'text', model: null },
      { prop: 'addressDetails', label: t('shoppingAddress.addressDetails'), placeholder: t('shoppingAddress.addressDetailsP'), component: 'el-input', type: 'text', model: null }
    ]

    const shoppingAddressRole = {
      userName: [{ required: true, message: t('shoppingAddress.userName').concat(t('common.isRequired')), trigger: 'blur' }],
      customerName: [{ required: true, message: t('shoppingAddress.customerName').concat(t('common.isRequired')), trigger: 'blur' }],
      telephone: [{ required: true, message: t('shoppingAddress.telephone').concat(t('common.isRequired')), trigger: 'blur' }],
      addressSheng: [{ required: true, message: t('shoppingAddress.addressSheng').concat(t('common.isRequired')), trigger: 'blur' }],
      addressShi: [{ required: true, message: t('shoppingAddress.addressShi').concat(t('common.isRequired')), trigger: 'blur' }],
      addressXian: [{ required: true, message: t('shoppingAddress.addressXian').concat(t('common.isRequired')), trigger: 'blur' }],
      addressStreet: [{ required: true, message: t('shoppingAddress.addressStreet').concat(t('common.isRequired')), trigger: 'blur' }],
      addressDetails: [{ required: true, message: t('shoppingAddress.addressDetails').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [

      { prop: 'userName', label: t('shoppingAddress.userName'), sortable: 'custom' },
      { prop: 'customerName', label: t('shoppingAddress.customerName'), sortable: 'custom' },
      { prop: 'telephone', label: t('shoppingAddress.telephone'), sortable: 'custom' },
      { prop: 'addressSheng', label: t('shoppingAddress.addressSheng'), sortable: 'custom' },
      { prop: 'addressShi', label: t('shoppingAddress.addressShi'), sortable: 'custom' },
      { prop: 'addressXian', label: t('shoppingAddress.addressXian'), sortable: 'custom' },
      { prop: 'addressStreet', label: t('shoppingAddress.addressStreet'), sortable: 'custom' },
      { prop: 'addressDetails', label: t('shoppingAddress.addressDetails'), sortable: 'custom' },
      { prop: 'createTime', label: t('common.createTime'), formatter: (row: ShoppingAddressModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: ShoppingAddressModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as ShoppingAddressSearchModel,
      tableData: Array<ShoppingAddressModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'shoppingAddress.edit',
        create: 'shoppingAddress.create'
      },
      dialogFormVisible: false,
      shoppingAddressRole: shoppingAddressRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as ShoppingAddressAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as ShoppingAddressUpdateModel,
      editRow: {} as ShoppingAddressModel,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: ShoppingAddressPageSearchModel = {
          userName: dataMap.searchFormModel.userName,
          customerName: dataMap.searchFormModel.customerName,
          telephone: dataMap.searchFormModel.telephone,
          addressSheng: dataMap.searchFormModel.addressSheng,
          addressShi: dataMap.searchFormModel.addressShi,
          addressXian: dataMap.searchFormModel.addressXian,
          addressStreet: dataMap.searchFormModel.addressStreet,
          addressDetails: dataMap.searchFormModel.addressDetails,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchShoppingAddress(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        const createData: ShoppingAddressAddModel = {
          userName: dataMap.createModel.userName,
          customerName: dataMap.createModel.customerName,
          telephone: dataMap.createModel.telephone,
          addressSheng: dataMap.createModel.addressSheng,
          addressShi: dataMap.createModel.addressShi,
          addressXian: dataMap.createModel.addressXian,
          addressStreet: dataMap.createModel.addressStreet,
          addressDetails: dataMap.createModel.addressDetails
        }
        const result = await addShoppingAddress(createData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.createSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async updateNameSubmit() {
        const updateData: ShoppingAddressUpdateModel = {
          id: dataMap.updateModel.id,
          userName: dataMap.updateModel.userName,
          customerName: dataMap.updateModel.customerName,
          telephone: dataMap.updateModel.telephone,
          addressSheng: dataMap.updateModel.addressSheng,
          addressShi: dataMap.updateModel.addressShi,
          addressXian: dataMap.updateModel.addressXian,
          addressStreet: dataMap.updateModel.addressStreet,
          addressDetails: dataMap.updateModel.addressDetails
        }
        const result = await updateShoppingAddress(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removeShoppingAddress(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemoveShoppingAddress(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.userName = dataMap.editRow.userName
        dataMap.updateModel.customerName = dataMap.editRow.customerName
        dataMap.updateModel.telephone = dataMap.editRow.telephone
        dataMap.updateModel.addressSheng = dataMap.editRow.addressSheng
        dataMap.updateModel.addressShi = dataMap.editRow.addressShi
        dataMap.updateModel.addressXian = dataMap.editRow.addressXian
        dataMap.updateModel.addressStreet = dataMap.editRow.addressStreet
        dataMap.updateModel.addressDetails = dataMap.editRow.addressDetails
      },
      createReset() {
        console.log('create reset')
      }
    })
    const handleCreate = () => {
      dataMap.dialogStatus = 'create'
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: ShoppingAddressModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.userName = row.userName
        dataMap.updateModel.customerName = row.customerName
        dataMap.updateModel.telephone = row.telephone
        dataMap.updateModel.addressSheng = row.addressSheng
        dataMap.updateModel.addressShi = row.addressShi
        dataMap.updateModel.addressXian = row.addressXian
        dataMap.updateModel.addressStreet = row.addressStreet
        dataMap.updateModel.addressDetails = row.addressDetails
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    onMounted(() => {
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      searchFormRef,
      ...toRefs(dataMap)
    }
  }
})
</script>
